import React, { Component } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { autobind } from 'packages/core/lib';
import Spinner from '../../../components/Spinner';
import Device from '../../../devices/device';
import ButtonFilter from '../../../components/ButtonFilter';
import Translator from '../../../requests/apa/Translator';
import Asset from "../../../requests/apa/Asset";
import api from './../../requests/api/';
import { Schedule, IScheduleGroupItemProps, IScheduleProps, IScheduleLabelProps } from './schedule';
import { showNotification } from '../../../actions/notification';
import { showModal, AAF_MODAL_CALENDAR_PHASE, HIDE_MODAL } from '../../../actions/modal';
import { COMPONENT_WORLD_CUP, ACTION_SCHEDULE } from '../../utls/constantsMetrics';
import { setMetricsEvent } from "../../../actions/metrics";
import store from '../../../store';
import Utils, { setInitialFocus } from '../../../utils/Utils';
import { Match, MatchDate, Phase } from 'src/mundial/requests/interfaces';
import { getSeparators, isScheduled, getApaMatchLiveButton, playWorldCupChannel, getApaAlertAutoHideTime, isTeamPlaceholder } from '../../utls/utils';
import './_styles.scss';
import { cls } from 'packages/components';


interface IPlanselectorState {
  data: IScheduleProps;
  matches: Match[],
  isLoading: boolean;
}


declare var window: any;
const TODAY = "TODAY";
const ALL = "ALL";
class Calendar extends Component<RouteComponentProps & IScheduleProps, IPlanselectorState> {
  public keys = Device.getDevice() && Device.getDevice().getKeys() || null;
  private round: string;
  private navDirection: string;
  private rounds: Phase[];
  private defaultFlag: string = Asset.get('matches_result_placehoderFlag_img');
  private firstLoad: boolean = true;

  constructor(props: RouteComponentProps & IScheduleProps) {
    super(props);
    this.state = {
      isLoading: true,
      data: {
        label: {
          team: '',
          hour: '',
          button_play: ''
        },
        scheduleHeader: {},
        scheduleData: [],
      },
      matches: []
    };
    this.round = ALL;
  }

  componentDidMount() {
    this.getApiData();
    this.addEventListener();
    Utils.setInitialFocus(".ribbon-categories.mundial a:nth-child(2)")
  }

  componentWillUnmount() {
    this.removeEventListener();
  }

  private onClick(match: any) {
    //TODO: Implement if necesary.
  }

  private onFocus(match: any, id: string){

    const expresion = /\d+/gi;
    const [group, row] = id.match(expresion) || [];
    const tableHeigth = 375.15625;
    const [scheduleTable, ...rest] = document.getElementsByClassName('schedule-table');
    const selectedElement: HTMLElement | null = document.getElementById(id);

    if (selectedElement) {
      let htmlElement: HTMLElement = selectedElement;
      while (htmlElement.tagName !== 'TABLE') {
        if (htmlElement.parentElement) {
          htmlElement = htmlElement.parentElement;
        } else {
          break;
        }
      }

      const [htmlClientRects, ...rest] = htmlElement.getClientRects();
      const {top} = htmlClientRects;

      if (this.navDirection === 'up') {
        if (row === '0' || row === '1') {
          scheduleTable.scrollTop -= tableHeigth - top - 32.5;
        }
      }
    }
  }

  private onClickWatchNow(match: any) {

    this.sendMetric(match);

    if (getApaMatchLiveButton().enable && getApaMatchLiveButton().group_id !== '') {
      playWorldCupChannel(getApaMatchLiveButton().group_id)
    }
  }

  private getRoundName(roundId: string, matchRoundId: string): string {
    if (!this.rounds) return '';
    const groupPhasesId = 'GN8N2CJNFGC0M4G';
    const id = roundId == groupPhasesId ? matchRoundId : roundId;
    const { name = '' } = this.rounds.find(((round) => round.id === id)) || {};
    return name
  }

  private getTitle(roundId: string, matchRoundId: string, date: MatchDate, pipe: string): string {
    return `${this.getRoundName(roundId, matchRoundId)} ${pipe} ${this.formatScheduleDate(date)}`
  }

  private async getApiData(): Promise<void> {

    const {matches} = this.state; 
    let allMatches: Match[] = [];

    if (!this.rounds) {
      const phases = await api.getPhases();
      const { groups, matchRounds, rounds } = phases;

      this.rounds = [...rounds, ...matchRounds];

    }

    if (matches && matches.length>0) {
      allMatches = matches
    } else {
      allMatches = await api.getAllMatches();
    }

    let matchCalendar: any = [];

    if (this.round === TODAY) {
      const today = this.getDateFromDateTime(Utils.now());
      matchCalendar = allMatches.filter((match) => this.getDateFromMatchDate(match.date) === today);
    } else if (this.round === ALL) {
      matchCalendar = allMatches;
    } else {
      matchCalendar = allMatches.filter((match) => (match.matchRoundId === this.round || match.roundId === this.round));
    }

    const { pipe = '', versusdetail = '' } = getSeparators();
    const apaConfiguration = getApaMatchLiveButton();
    const dataGroups = [... new Set(matchCalendar.map((cal: any) => {
      return this.getTitle(cal.roundId || '', cal.matchRoundId || '', cal.date, pipe);
    }))];
    let previousMatchDate = '';
    const newScheduleData: IScheduleGroupItemProps[] = dataGroups.map((title: string) => {
      return {
        title,
        schedule: matchCalendar.filter((match: any) => this.getTitle(match.roundId || '', match.matchRoundId || '', match.date, pipe) === title).map(((match: any) => {
          let canWatchNow = true;
          if (previousMatchDate === match.date){
            canWatchNow = false
          }

          previousMatchDate = match.date;
          const localImg = isTeamPlaceholder(match.homeTeam) ? this.defaultFlag : match.homeTeam.flag;
          const visitorImg = isTeamPlaceholder(match.awayTeam) ? this.defaultFlag : match.awayTeam.flag;

          return {
            scheduleRound: this.getRoundName(match.roundId || '', match.matchRoundId || ''),
            scheduleHour: this.formatScheduleMatchDate(match.date),

            scheduleTeam: `${match.homeTeam.name} ${versusdetail} ${match.awayTeam.name}`,
            scheduleLocalImg: localImg,
            scheduleVisitorImg: visitorImg,
            canWatchNow: canWatchNow && apaConfiguration.enable && match.status === 'IN_PROGRESS',
            isScheduled: isScheduled(match),
            onClick: () => { this.onClick(match) },
            onFocus: (id: string) => this.onFocus(match, id) ,
            onClickButton: () => { this.onClickWatchNow(match) },
          }
        }))
      }
    });

    const data: IScheduleProps = {
      label: this.getLabels(),
      scheduleHeader: {},
      scheduleData: newScheduleData
    }

    this.setState({ isLoading: false, data, matches : allMatches });

  }

  sendMetric(data: any): void {
    const { homeTeam: { name: homeTeamName }, awayTeam: { name: awayTeamName } } = data;
    const { versus } = getSeparators();
    const label = `ver ahora - ${homeTeamName} ${versus} ${awayTeamName}`;
    //calendario 	ver ahora - {{nombre de los equipos}} 
    Utils.sendMetric(this.props, ACTION_SCHEDULE, label, COMPONENT_WORLD_CUP);
  }

  showNotificationNextMatch(nextMatch: string): void {
    store.dispatch(showNotification({
      show: true,
      title: Translator.get('match_alert_title_NotMatch_label'),
      msg: Translator.get('match_alert_description_notMatch_label', '').replace('@nextMatch', nextMatch),
      type: 'notification',
      timeShowing: getApaAlertAutoHideTime(),
    }));
  }

  showNotificationNoMatch(): void {
    store.dispatch(showNotification({
      show: true,
      title: Translator.get('match_alert_title_NotMatch_label'),
      msg: Translator.get('match_alert_description_notMatchDefault_label', ''),
      type: 'notification',
      timeShowing: getApaAlertAutoHideTime(),
    }));
  }

  private formatScheduleDate(d: MatchDate): string {
    return `${d.weekday}, ${d.day} de ${this.getMonthName(d.month - 1)}`;
  }

  private getDateFromDateTime(d: Date): string {
    return `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')}`
  }

  private getDateFromMatchDate(d: MatchDate): string {
    return `${d.year}-${(d.month).toString().padStart(2, '0')}-${d.day.padStart(2, '0')}`
  }

  private getNumberFromDateTime(d: Date): number {
    return parseFloat(`${d.getFullYear()}${(d.getMonth() + 1).toString().padStart(2, '0')}${d.getDate().toString().padStart(2, '0')}`);
  }

  private getNumberFromMatchDate(d: MatchDate): number {
    return parseFloat(`${d.year}${(d.month).toString().padStart(2, '0')}${d.day.padStart(2, '0')}`);
  }

  private formatScheduleMatchDate(d: MatchDate): string {
    const hoursAbbreviation = Translator.get('match_detail_hourAbbreviation_label', 'hs');
   
    return `${d.hours}:${d.minutes} ${hoursAbbreviation}`;

  }

  private getMonthName(n: number): string {
    const month = ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"];
    return month[n];
  }

  private getAllMatch(): Match[] {
    const {matches} = this.state; 
    return (matches)
  }

  private setFocus(element: string = '.aaf_colored-button.btn-filter.focusable'): void {
    
    const [scheduleTable, ...rest] = document.getElementsByClassName('schedule-table');

    Utils.setInitialFocus(element);
    if (scheduleTable) {
      scheduleTable.scrollTop = 0;
    }

  }

  @autobind
  handleBack() {
    store.dispatch({
      type: HIDE_MODAL,
      modalType: AAF_MODAL_CALENDAR_PHASE
    });
    this.setFocus();
  };


  @autobind
  async handleSelectOption(option: { id: string, name: string }, callback : () => void) {

    if (option.id === TODAY) {
      const today = this.getDateFromDateTime(Utils.now());
      let matchCalendar: Match[] = this.getAllMatch().filter((match) => this.getDateFromMatchDate(match.date) === today);
      if (matchCalendar.length === 0) {
        //STV-16188 Se actualiza el texto Informativo
        this.showNotificationNoMatch()
        return;
      } 
    } 

    this.round = option.id;
    this.getApiData();
    this.setFocus();
    callback();
  };



  @autobind
  onModalFilter() {
    const modal = {
      modalType: AAF_MODAL_CALENDAR_PHASE,
      modalProps: {
        options: this.getRounds(),
        handleSelectOption: this.handleSelectOption,
        handleBack: this.handleBack,
        hasTodayMatches: false,
        round : this.firstLoad ? ALL : this.round,
      }
    };
    if (this.firstLoad){
      this.firstLoad = false;
    }
    store.dispatch(showModal(modal));
  }

  private getLabels(): IScheduleLabelProps {
    return {
      hour: Translator.get("calendar_result_hour_label", ""),
      team: Translator.get("calendar_result_teams_label", ""),
      button_play: Translator.get("calendar_result_option_button_play", ""),
    }
  }

  private getRounds() {
    return [
      {
        "id": TODAY,
        "name": Translator.get("calendar_phases_option_item_today", "Hoy")
      },
      {
        "id": "GN2TACB00XHVX4W",
        "name": this.getRoundName("GN2TACB00XHVX4W", "")
      },
      {
        "id": "GN492TFBG7DATDF",
        "name": this.getRoundName("GN492TFBG7DATDF", "")
      },
      {
        "id": "GN03HWNER5MEW45",
        "name": this.getRoundName("GN03HWNER5MEW45", "")
      },
      {
        "id": "GNFPAYWC9M394J5",
        "name": this.getRoundName("GNFPAYWC9M394J5", "")
      },
      {
        "id": "GNDS14ZN19MA8AE",
        "name": this.getRoundName("GNDS14ZN19MA8AE", "")
      },
      {
        "id": "GNBHVT79GEK8PDY",
        "name": this.getRoundName("GNBHVT79GEK8PDY", "")
      },
      {
        "id": "GN0RDNSRNFX8CN5",
        "name": this.getRoundName("GN0RDNSRNFX8CN5", "")
      },
      {
        "id": "GNFEPTP0PBTFA68",
        "name": this.getRoundName("GNFEPTP0PBTFA68", "")
      },
      {
        "id": ALL,
        "name": Translator.get("calendar_phases_option_item_all", "Todos")
      }]
  }

  addEventListener() {
    document.removeEventListener("keydown", this.handleKeyDown);
    document.addEventListener("keydown", this.handleKeyDown);
    document.removeEventListener("sn:willfocus", this.onWillFocus);
    document.addEventListener("sn:willfocus", this.onWillFocus);
  }

  removeEventListener() {
    document.removeEventListener("keydown", this.handleKeyDown);
    document.removeEventListener("sn:willfocus", this.onWillFocus);
  }

  @autobind
  handleKeyDown(e: KeyboardEvent){
    const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;
    if(currentKey === 'RED'){
        this.onModalFilter();
    }
  }

  @autobind
  onWillFocus(params: any){
    if(params.target.id) {
      this.navDirection = params.detail.direction;
    }
  }

  @autobind
  handleMatchClick() {
  }

  @autobind
  handleMatchFocus() {
  }


  public render(): JSX.Element {
    const { data, isLoading } = this.state;
    const navigation = {
      down : '#group-0-row-0'
    }

    if (isLoading) {
      return <Spinner className="worldcup-schedule" loadingMessage='' />
    } else {
      return <div className={cls(Device.getDevice().getPlatform() , 'worldcup-schedule-container')}>
        <Schedule {...data}>
          <ButtonFilter onModalFilter={this.onModalFilter} navigation={navigation} />
        </Schedule>
      </div>
    }
  }
}

export default connect(null, { setMetricsEvent })(withRouter(Calendar));





// WEBPACK FOOTER //
// ./src/mundial/Tabs/Calendar/index.tsx